import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="container">
        <div className="privacy-content">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>Information We Collect</h2>
            <p>We collect information you provide when creating an account, including your name, email address, and profile picture. We also store content you upload, text you provide, and chat conversations with AI agents. Payment information is processed securely through third-party payment processors.</p>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>We use your information to provide, maintain, and improve our services, process your content to create AI agents, enable chat functionality, process payments, and communicate with you about your account.</p>
          </section>

          <section>
            <h2>Information Sharing</h2>
            <p>We do not sell your personal information. We may share information with service providers necessary to operate our platform, or as required by law. Your data may be processed by third-party AI services to generate responses.</p>
          </section>

          <section>
            <h2>Data Security</h2>
            <p>We implement security measures to protect your information. However, no method of transmission over the internet is 100% secure. Your content is stored securely and accessible only to you and our systems for processing.</p>
          </section>

          <section>
            <h2>Your Rights</h2>
            <p>You can access, update, or delete your account information at any time through your account settings. You may also request deletion of your data by contacting us.</p>
          </section>

          <section>
            <h2>Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. Continued use of our service after changes constitutes acceptance of the updated policy.</p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
